var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"requests-list"},[_c('SpaceDescription',[_c('Headline',{attrs:{"size":1}},[_vm._v("Accreditation Requests")])],1),_c('RequestsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }